"use client";

import { useEffect, useRef } from "react";
import { safeCapture } from "@/lib/analytics/safeCapture";

/**
 * Fires `blog_post_viewed` once per post view so views can be broken down by
 * `post_slug` / `post_tags` in PostHog. The ref guard stops StrictMode's
 * double-mounted effect from double-counting; navigating to a different post
 * changes `slug` and fires again.
 */
export function BlogPostViewTracker({
  slug,
  title,
  tags,
}: {
  slug: string;
  title: string;
  tags: string[];
}) {
  const lastSlug = useRef<string | null>(null);

  useEffect(() => {
    if (lastSlug.current === slug) return;
    lastSlug.current = slug;
    safeCapture("blog_post_viewed", { post_slug: slug, post_title: title, post_tags: tags });
    // title/tags are derived from the same post as slug; only a slug change is a new view.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  return null;
}
